import React, { useState, useEffect } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';

// Blog resimlerini import ediyoruz
import webTrendsImage from '../images/blog/web-trends-2024.png';
import mobileAppImage from '../images/blog/mobile-app-guide.png';
import ecommerceSeoImage from '../images/blog/ecommerce-seo.png';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Blog yazıları - gerçek resimlerle güncellenmiş
  const blogPosts = [
    {
      id: 1,
      title: "Web Geliştirme Trendleri 2024",
      excerpt: "2024 yılında web geliştirme dünyasında öne çıkan trendleri ve teknolojileri keşfedin. Yapay zeka, PWA, WebAssembly ve daha fazlası.",
      content: "Web geliştirme dünyası sürekli olarak değişiyor ve gelişiyor. 2024 yılında öne çıkan trendler...",
      slug: "web-gelistirme-trendleri-2024",
      image: webTrendsImage,
      author: "Mobilinfo Ekibi",
      publishDate: "2024-01-15",
      readTime: "5 dk",
      tags: ["Web Geliştirme", "Trendler", "Teknoloji"]
    },
    {
      id: 2,
      title: "Mobil Uygulama Geliştirme Rehberi",
      excerpt: "Başarılı mobil uygulama geliştirmek için bilmeniz gereken temel prensipler ve ipuçları. Platform seçimi, UX tasarımı ve performans optimizasyonu.",
      content: "Mobil uygulama geliştirme süreci karmaşık görünse de, doğru yaklaşımla başarılı sonuçlar elde edebilirsiniz...",
      slug: "mobil-uygulama-gelistirme-rehberi",
      image: mobileAppImage,
      author: "Mobilinfo Ekibi",
      publishDate: "2024-01-10",
      readTime: "8 dk",
      tags: ["Mobil Uygulama", "Geliştirme", "Rehber"]
    },
    {
      id: 3,
      title: "E-ticaret Sitesi Optimizasyonu",
      excerpt: "E-ticaret sitenizin performansını artırmak ve daha fazla satış yapmak için SEO stratejileri. Teknik SEO, içerik pazarlama ve yerel SEO.",
      content: "E-ticaret sitelerinde SEO optimizasyonu, organik trafik artışı ve satış artışı için kritik önem taşır...",
      slug: "e-ticaret-sitesi-optimizasyonu",
      image: ecommerceSeoImage,
      author: "Mobilinfo Ekibi",
      publishDate: "2024-01-05",
      readTime: "6 dk",
      tags: ["E-ticaret", "SEO", "Optimizasyon"]
    }
  ];

  useEffect(() => {
    // Simüle edilmiş API çağrısı
    setTimeout(() => {
      setPosts(blogPosts);
      setLoading(false);
    }, 1000);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "Mobilinfo Blog",
    "description": "Web ve mobil uygulama geliştirme, teknoloji trendleri ve dijital çözümler hakkında güncel yazılar",
    "url": "https://mobilinfo.com.tr/blog",
    "publisher": {
      "@type": "Organization",
      "name": "Mobilinfo Bilgi Teknolojileri",
      "url": "https://mobilinfo.com.tr"
    },
    "blogPost": blogPosts.map(post => ({
      "@type": "BlogPosting",
      "headline": post.title,
      "description": post.excerpt,
      "url": `https://mobilinfo.com.tr/blog/${post.slug}`,
      "datePublished": post.publishDate,
      "author": {
        "@type": "Organization",
        "name": post.author
      }
    }))
  };

  return (
    <>
      <SEO
        title="Blog - Mobilinfo Bilgi Teknolojileri | Web ve Mobil Uygulama Geliştirme"
        description="Web ve mobil uygulama geliştirme, teknoloji trendleri, SEO optimizasyonu ve dijital çözümler hakkında güncel blog yazıları. Mobilinfo uzman ekibinden öğrenin."
        keywords="web geliştirme blog, mobil uygulama blog, teknoloji trendleri, SEO blog, dijital çözümler blog"
        canonical="/blog"
        structuredData={structuredData}
      />
      
      <div>
        <NavBar />
      </div>
      
      <div className="min-h-screen bg-gray-50 pt-20">
        <div className="container mx-auto px-4 py-12">
          {/* Blog Header */}
          <div className="text-center mb-12" data-aos="fade-up">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Mobilinfo Blog
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Web ve mobil uygulama geliştirme, teknoloji trendleri ve dijital çözümler hakkında güncel yazılar
            </p>
          </div>

          {/* Blog Posts Grid */}
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post, index) => (
                <article 
                  key={post.id} 
                  className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="aspect-w-16 aspect-h-9">
                    <img 
                      src={post.image} 
                      alt={post.title}
                      className="w-full h-48 object-cover"
                    />
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                      <span>{post.publishDate}</span>
                      <span className="mx-2">•</span>
                      <span>{post.readTime} okuma</span>
                    </div>
                    
                    <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                      <Link 
                        to={`/blog/${post.slug}`}
                        className="hover:text-cyan-500 transition-colors"
                      >
                        {post.title}
                      </Link>
                    </h2>
                    
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex flex-wrap gap-2 mb-4">
                      {post.tags.map((tag, tagIndex) => (
                        <span 
                          key={tagIndex}
                          className="px-2 py-1 bg-cyan-100 text-cyan-800 text-xs rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    
                    <Link 
                      to={`/blog/${post.slug}`}
                      className="inline-flex items-center text-cyan-500 hover:text-cyan-600 font-medium"
                    >
                      Devamını Oku
                      <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default Blog; 